import React, { useState } from 'react';
import { auth } from '../../firebase';
import { useAuth } from '../../context/AuthContext';
import { changeOwnPassword, validateNewPassword, authMessage } from '../../utils/passwords';
import './Auth.css';

/**
 * Shown instead of the app right after signing in with a temporary password
 * the owner set (users/{uid}.mustChangePassword). Same idea as "change
 * password at next sign-in" in Google Workspace / Microsoft 365.
 */
export default function ForcePasswordChange() {
  const { user, logout, passwordChanged } = useAuth();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    const invalid = !current ? 'Enter the temporary password you just signed in with.' : validateNewPassword(next, confirm, current);
    if (invalid) { setError(invalid); return; }
    setBusy(true); setError('');
    try {
      await changeOwnPassword(auth.currentUser, current, next);
      passwordChanged();
    } catch (err) {
      setError(authMessage(err, 'Could not change the password. Please try again.'));
      setBusy(false);
    }
  };

  return (
    <div className="auth">
      <div className="auth__card" style={{ maxWidth: 440 }}>
        <div className="auth__logo"><span>Desi Bites</span></div>
        <h1 className="auth__title">Choose a new password</h1>
        <p className="auth__sub">
          You signed in with a temporary password. Pick your own to continue{user?.email ? <> as <b>{user.email}</b></> : null}.
        </p>
        {error && <div className="auth__error">{error}</div>}
        <form className="auth__form" onSubmit={submit}>
          <div className="auth__field">
            <label className="auth__label" htmlFor="fpc-current">Temporary password</label>
            <input id="fpc-current" className="auth__input" type={show ? 'text' : 'password'} autoComplete="current-password"
              value={current} onChange={(e) => setCurrent(e.target.value)} />
          </div>
          <div className="auth__field">
            <label className="auth__label" htmlFor="fpc-new">New password</label>
            <input id="fpc-new" className="auth__input" type={show ? 'text' : 'password'} autoComplete="new-password" placeholder="At least 6 characters"
              value={next} onChange={(e) => setNext(e.target.value)} />
          </div>
          <div className="auth__field">
            <label className="auth__label" htmlFor="fpc-confirm">Confirm new password</label>
            <input id="fpc-confirm" className="auth__input" type={show ? 'text' : 'password'} autoComplete="new-password"
              value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          </div>
          <label className="acct__pw-show">
            <input type="checkbox" checked={show} onChange={(e) => setShow(e.target.checked)} /> Show passwords
          </label>
          <button className="auth__btn" type="submit" disabled={busy}>{busy ? 'Saving…' : 'Set password & continue'}</button>
        </form>
        <div style={{ marginTop: 16, textAlign: 'center' }}>
          <button type="button" className="acct__logout" onClick={logout}>Sign out</button>
        </div>
      </div>
    </div>
  );
}
